module.exports = __webpack_public_path__ + "935d55eec22a5ca04fb19936fa96ae2e.pdf";